import React, {useCallback} from 'react';
import {Link} from '@mui/material';
import SCCheckbox from './SCCheckbox.js';

const StopPropagationLink = props=>{
    let {text, href} = props;
    let onClick = useCallback(ev=>{
        ev.stopPropagation();
        window.open(href, '_blank').focus();
    }, [href]);
    return <Link onClick={onClick}>{text}</Link>;
};

const ConsentCheckbox = props=>{
    return <SCCheckbox required label={<span>
      אני מסכימ.ה ל<StopPropagationLink text="תנאי השימוש" href="/terms"/> ול<StopPropagationLink text="מדיניות הפרטיות" href="/privacy-policy"/>
    </span>} {...props}/>;
};

export default ConsentCheckbox;
